import { useEffect, useState } from 'react'

export default function useShowWelcomeMessage(): { showMessage: boolean; dismiss: () => void } {
  const [showMessage, setShowMessage] = useState(false)

  useEffect(() => {
    const isDismissed = sessionStorage.getItem('chatBubbleDismissed')
    setShowMessage(!isDismissed)
  }, [])

  const dismiss = () => {
    sessionStorage.setItem('chatBubbleDismissed', 'true')
    setShowMessage(false)
  }

  return { showMessage, dismiss }
}
